<template>
  <div class="not-found w-full">
    <div class="content">
      <h1 class="error-code">404</h1>
      <p class="message">Страница не найдена</p>
      <button class="home-button" @click="goHome">Перейти на Главную страницу</button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
const goHome = () => router.push('/')
</script>

<style scoped>
.not-found {
    background-image: url('../public/images/404.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}

.content {
    text-align: center;
    z-index: 2;
}

.shop-name {
    font-size: 1.4rem;
    letter-spacing: 2px;
    color: #b5917f;
    margin-bottom: 0.5rem;
}

.error-code {
    font-size: 7rem;
    font-weight: 500;
    color: #a37c63;
    margin: 0;
}

.message {
    font-size: 1.2rem;
    margin: 0.5rem 0 1.5rem;
    color: #b5917f;
}

.home-button {
    cursor: pointer;
    border: 1px solid #a37c63;
    background: transparent;
    color: #a37c63;
    padding: 0.6rem 1.2rem;
    border-radius: 5px;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.home-button:hover {
    border: 1px solid #bbc4a2;
    background-color: #bbc4a2;
}
</style>
